import { openDialog } from '../../../react/features/base/dialog/actions';
import { getLocalizedDurationFormatter } from '../../../react/features/base/i18n/dateUtil';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { showNotification } from '../../../react/features/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../../react/features/notifications/constants';
import VideoQualityDialog from '../../../react/features/video-quality/components/VideoQualityDialog.web';
import { sendStatsToKibana } from '../analytics/kibana/actions';
import { KIBANA_MESSAGES } from '../analytics/kibana/constants';
import { SET_PRESSURE_RECORD } from './actionTypes';
import { setPressureNotification } from './actions';
import { isCriticalPressure } from './functions';
function showPressureWarningNotification(record, store) {
    const { dispatch, getState } = store;
    const state = getState();
    const { wasNotificationShown } = state['wildix/features/pressure-observer'];
    const isAudioOnly = Boolean(state['features/base/audio-only'].enabled);
    if (isCriticalPressure(record, state) && !wasNotificationShown && !isAudioOnly) {
        dispatch(showNotification({
            appearance: 'warning-with-actions',
            icon: 'warning',
            customActionNameKey: ['videoStatus.performanceSettings'],
            customActionHandler: [
                () => dispatch(openDialog(VideoQualityDialog))
            ],
            descriptionKey: 'notify.cpuWarningDescription',
            titleKey: 'notify.cpuWarningTitle'
        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
        dispatch(setPressureNotification(true));
    }
}
const data = {
    criticalStart: false,
    criticalEnd: false,
    criticalTime: 0,
    criticalDuration: '00:00'
};
function sendPressureLogsToKibana(record, store) {
    const { dispatch, getState } = store;
    const state = getState();
    if (isCriticalPressure(record, state)) {
        data.criticalStart = true;
        data.criticalEnd = false;
        data.criticalTime = record.time;
        data.criticalDuration = '00:00';
        dispatch(sendStatsToKibana([data], KIBANA_MESSAGES.PressureObserver));
    }
    else if (data.criticalStart) {
        const diff = record.time - data.criticalTime;
        const duration = getLocalizedDurationFormatter(diff);
        data.criticalStart = false;
        data.criticalEnd = true;
        data.criticalTime = 0;
        data.criticalDuration = duration;
        dispatch(sendStatsToKibana([data], KIBANA_MESSAGES.PressureObserver));
    }
}
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case SET_PRESSURE_RECORD: {
            const record = action.value;
            showPressureWarningNotification(record, store);
            sendPressureLogsToKibana(record, store);
        }
    }
    return next(action);
});
